import React, {useState} from "react";
import './interactive-videos.css';

// ..... images .......
import interactive from '../../../assets/images/intractive-white.svg';
import mac from '../../../assets/images/mac.svg';
// import screen1 from '../../../assets/images/screen-1.svg';
import screen1 from '../../../assets/images/1.png';
import screen2 from '../../../assets/images/2.png';
import screen3 from '../../../assets/images/3.png';
import screen4 from '../../../assets/images/4.png';
import screen5 from '../../../assets/images/5.png';
import screen6 from '../../../assets/images/6.png';

function InteractiveVideos() {
   const [screen, setScreen] = useState(1);
   return (
       <div className="interactive-sec-content flex hr-right">
          <div className="content-box">
             <div className="interactive-box">
                <div className="icon width-50 margin-b-15">
                   <img src={interactive} alt=""/>
                </div>
                <div className="interactive-title rubik-medium font-40 margin-b-30 white-color">Interactive videos</div>
                <div className="line-30 font-20 margin-b-40">
                   Create videos for your customers and teams in minutes. Customize and embed across channels. Make them
                   interactive!
                </div>
                <div className="icon mac-book">
                   <img src={mac} alt=""/>
                   <div className={'screen icon ' + (screen === 1 ? 'active' : '')}>
                      <img src={screen1} alt=""/>
                   </div>
                   <div className={'screen icon ' + (screen === 2 ? 'active' : '')}>
                      <img src={screen2} alt=""/>
                   </div>
                   <div className={'screen icon ' + (screen === 3 ? 'active' : '')}>
                      <img src={screen3} alt=""/>
                   </div>
                   <div className={'screen icon ' + (screen === 4 ? 'active' : '')}>
                      <img src={screen4} alt=""/>
                   </div>
                   <div className={'screen icon ' + (screen === 5 ? 'active' : '')}>
                      <img src={screen5} alt=""/>
                   </div>
                   <div className={'screen icon ' + (screen === 6 ? 'active' : '')}>
                      <img src={screen6} alt=""/>
                   </div>
                </div>
                <ul className="video-types flex hr-space-between flex-wrap rubik-medium margin-b-30">
                   <li onClick={() => setScreen(1)} className={screen === 1 ? 'active' : ''}>Explainer Videos</li>
                   <li onClick={() => setScreen(2)} className={screen === 2 ? 'active' : ''}>How-to videos</li>
                   <li onClick={() => setScreen(3)} className={screen === 3 ? 'active' : ''}>Product Walkthroughs</li>
                   <li onClick={() => setScreen(4)} className={screen === 4 ? 'active' : ''}>Training Videos</li>
                   <li onClick={() => setScreen(5)} className={screen === 5 ? 'active' : ''}>Announcement Videos</li>
                   <li onClick={() => setScreen(6)} className={screen === 6 ? 'active' : ''}>Onboarding Videos</li>
                </ul>
                <div className="line-30 font-20">
                   Say goodbye to passive consumption. Viewers may annotate anywhere on the video and leave a comment or
                   a question for you. Drive more conversions, improve adoption and create delightful customer
                   experiences.
                </div>
             </div>
          </div>

       </div>
   )
}

export default InteractiveVideos;
